<template>
  <div :class="$style.article">
    <PImage :image-object="articleData.image" :class="$style.image" />
    <RichText :text-params="articleData.intro" :class="$style.intro" />
    <div :class="$style.body">
      <component
        :is="formatedSlices(slice)"
        v-for="(slice, sliceId) in articleBody"
        :key="sliceId"
        :slice="slice"
      />
    </div>
    <div :class="$style.cardList">
      <ColoredCard
        v-for="(card, cardId) in cardList"
        :key="cardId"
        :class="$style.card"
        :title="card.title"
        :description="card.description"
        :button-link="card.cta_link"
        :button-text="card.cta_text"
        :icon-url="card.icon.url"
        :background-color="card.background_color"
      />
    </div>
  </div>
</template>

<script>
import RichText from '~/components/RichText'
import PImage from '~/components/PImage'
import ColoredCard from '~/components/ColoredCard'
import {
  ArticleDocument,
  ArticleImage,
  TextBlock,
  ArticleLink,
} from '~/components/slices/ArticleSlice/components'

export default {
  name: 'PressArticle',

  components: {
    RichText,
    PImage,
    ColoredCard,
    ArticleDocument,
    ArticleImage,
    TextBlock,
    ArticleLink,
  },

  props: {
    articleData: {
      type: Object,
      default: () => ({}),
    },
  },

  async fetch() {
    const pressHub = await this.$prismic.api.getSingle('press_hub', {
      lang: this.$i18n.localeProperties.prismicIso,
    })
    this.cardList = pressHub.data.body.filter(
      (slice) => slice.slice_type === 'card_list'
    )[0]?.items
  },

  data() {
    return {
      cardList: null,
    }
  },

  computed: {
    articleBody() {
      return this.articleData.body
    },
  },

  methods: {
    formatedSlices(slice) {
      const sliceType = slice.slice_type
      switch (sliceType) {
        case 'article_text':
          return 'TextBlock'

        case 'article_image':
          return 'ArticleImage'

        case 'link':
          return 'ArticleLink'

        case 'document':
          return 'ArticleDocument'

        default:
          break
      }
    },
  },
}
</script>

<style lang="scss" module>
.image {
  width: 100%;
  height: 330px;
  border-radius: 8px;
  object-fit: cover;
}

.intro {
  margin-top: 80px;

  * {
    color: $gray-1000;

    font-size: 20px;
    line-height: 32px;

    &:not(:first-child) {
      margin-top: 16px;
    }
  }
}

.body {
  margin-top: 24px;

  h2 {
    margin-top: 40px;

    font-size: 20px;
    line-height: 32px;
  }
}

.summary {
  margin-top: 24px;

  color: $gray-700;
}

.cardList {
  display: flex;
  margin-top: 80px;
}

.card {
  flex-grow: 1;
  max-width: inherit;
  margin-right: 40px;

  &:last-child {
    margin-right: 0;
  }
}
</style>
